import { render } from "./Tour.vue?vue&type=template&id=2b7a6bfc&scoped=true"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"

import "./Tour.vue?vue&type=style&index=0&id=2b7a6bfc&scoped=true&lang=css"
import "./Tour.vue?vue&type=style&index=1&id=2b7a6bfc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7a6bfc"]])

export default __exports__